import { Options } from 'rehype-sanitize'

/** HTML（React）表示時にに許可するHTMLタグと属性を指定する.*/
export const allowedRenderSchema: Options = {
  attributes: {
    a: ['href'],
    img: ['src'],
    span: [
      [
        'style',
        /^color:\s*(#[0-9a-fA-F]{0,6}|rgb\(\s*(?:[0-9]{1,3}\s*,\s*){2}[0-9]{1,3}\s*\))\s*$/,
      ],
    ],
  },
  protocols: {
    href: ['http', 'https', 'mailto', 'tel'],
    src: ['http', 'https'],
  },
  tagNames: [
    'a',
    'del',
    'em',
    'h1',
    'h2',
    'h3',
    'img',
    'li',
    'ol',
    'p',
    'span',
    'strike',
    'strong',
    'ul',
  ],
}

/**
 * プレーンテキスト表示時に許可するHTMLタグと属性を指定する.
 *
 * リンク情報は特殊表記で残すため aタグは許可する.
 */
export const allowedPlainTextSchema: Options = {
  attributes: {
    a: ['href'],
  },
  protocols: {
    href: ['http', 'https', 'mailto', 'tel'],
  },
  tagNames: ['a'],
}

/**
 * Excel/Googleスプレッドシートのペースト時に許可するHTMLタグと属性を指定する.
 */
export const allowedPastedMsoCellSchema: Options = {
  tagNames: ['br'],
}

/**
 * HTMLエディター入力時に許可するHTMLタグと属性を指定する.
 *
 * 会話カードエディタ下位互換性対応: 保存時には許可しないタグを表示時には allowedRenderSchema に追加で許可する.
 */
export const allowedEditorInputSchema: Options = {
  ...allowedRenderSchema,
  tagNames: [...(allowedRenderSchema.tagNames as string[]), 'b', 'i'],
}
